import React, { useEffect, useState } from "react";
import { padalaServices } from "../services/PadalaServices";
import { adminServices } from "../services/AdminServices";
import DataTable, { Alignment } from "react-data-table-component";
import Button1 from "../components/Button1";
import Modal from "react-modal";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import withAuthorization from "../components/withAuthorization";
import SearchBar from "../components/SearchBar";
const POSStatusReports = () => {
  const [kioskSales, setKioskSales] = useState(null);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    getPadala();
  }, []);

  // setTimeout(()=>{
  //   getPadala();
  // },60000);

  function convertMinutes(totalMinutes) {
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor(totalMinutes % (60 * 24) / 60);
    const minutes = totalMinutes % 60;
    if (days == 0 && hours == 0) {
      return `${minutes} minutes`;
    }
    if (days == 0) {
      return `${hours} hours, ${minutes} minutes`;
    }
    return `${days} days, ${hours} hours, ${minutes} minutes`;
  }
  const getPadala = () => {
    adminServices.storeProcedure2('pos_machine_report', {}).then(r => {
      setKioskSales(null);
      setKioskSales(r.data);
      setData(r.data);
      setFilteredData(r.data);
      var _col = [{
        name: 'Username',
        selector: data => data.username,
        sortable: true
      }, {
        name: 'Merchant Name',
        selector: data => data.merchant_name,
        sortable: true
      }, {
        name: 'Device Status',
        selector: data => data.online_status,
        sortable: true
      }, {
        name: 'FP Scanner Status',
        selector: data => data.scanner_status,
        sortable: true
      }, {
        name: 'Last Update',
        selector: data => data.as_of != null ? convertMinutes(data.as_of.replace(' minutes', '')) + " ago" : "",
        sortable: true
      }, {
        name: 'Status',
        selector: data => data.status == 1 ? "Active" : "Inactive",
        sortable: true
      }];
      setColumns(_col);
    }).catch(e => {
      if (e.response.status == 401) {
        window.location.href = "/";
      }
    });
  };
  return <div>
      <Modal show={true} />
      <h2>POS Status Report</h2>

      <div className="d-flex mb-3">
          <SearchBar placeholder="Search" onChange={e => {
        const value = e.target.value.toLowerCase();
        const filtered = data.filter(item => Object.keys(item).some(key => item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase())));
        setFilteredData(filtered);
      }} />
      </div>

      <DataTable columns={columns} data={filteredData} pagination highlightOnHover style={{
      zIndex: 0
    }}>
        
      </DataTable>
    </div>;
};
export default withAuthorization(POSStatusReports, 22);